import { render, staticRenderFns } from "./ActionButtonNew.vue?vue&type=template&id=3b7dc097"
import script from "./ActionButtonNew.vue?vue&type=script&lang=js"
export * from "./ActionButtonNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports